import { useNavigate, useParams } from "react-router-dom";
import { Header } from "../../components/Header";
import { Menu } from "../../components/Menu";
import { useOrder } from "../../hooks/useOrder";
import PixImg from "../../assets/images/pix.png";
import PagseguroImg from "../../assets/images/pagseguro.png";
import {
  calculatePriceFractionalToProduct,
  floatToCents,
  floatToPrice,
} from "../../functions/price_functions";
import { MainButton } from "../../components/MainButton";
import { useAppConfig } from "../../hooks/useAppConfig";
import { useEffect, useState } from "react";
import { Loading } from "../../components/Loading";
import { ConfigType } from "../../contexts/AppConfigContext";
import "./index.css";
import api from "../../services/api";
import { usePluginspace } from "../../hooks/usePluginspace";
import Swal from "sweetalert2";
import {
  CardType,
  CustomerType,
  OrderAddress,
  OrderContext,
  OrderIntegrationPlanType,
  OrderToSendType,
  OrderType,
  ProductType,
} from "../../contexts/OrderContext";
import RedeCardImg from "../../assets/images/rede-card.png";
import {
  cpfCnpjNoMask,
  cpfMask,
  maskCardNumber,
  rtcToText,
  cnpjMask,
} from "../../functions/mask";
import { v4 as uuidv4 } from "uuid";
import { ModalDelivery } from "../../components/ModalDelivery";
import { ModalTerms } from "../../components/ModalTerms";
import { ImageLazy } from "../../components/ImageLazy";
import { Checkbox } from "../../components/Checkbox";
import { useProduct } from "../../hooks/useProduct";
import { useFoodConfig } from "../../hooks/useFood";
import { ModalFinalizaVendaFood } from "../../components/ModalFinalizaVendaFood/modalFinalizaVendaFood";
import { json } from "stream/consumers";
import {
  arrayMessagesConnectionTotvs,
  arrayMessagesPaymentCard,
} from "../../functions/util";
import { error } from "console";
import { useFaceBookPixel } from "../../hooks/useFacebookPixel";
import { useFoodCartVisibilityValidation } from "../../hooks/useFoodCartVisibilityValidation";

type PlansType = {
  id: number;
  codePlan: number;
  installment: number;
};

export type IntegrationType = {
  id: number;
  pluginconfigId: number;
  brand: string;
  cardOperator: number;
  codePay: string;
  nameGateway: string;
  paymentPlans: PlansType[];
  typePay: string;
};

type CardTotvsType = {
  amount: number;
  deliveryfee: number;
  installments: number | string;
  cardholderName: string;
  cardNumber: null;
  nameCardBrand: string;
  expirationMonth: string;
  expirationYear: string;
  securityCode: string;
  brand: string;
  tokenizedPan: string;
  fingerprintSessionId: string;
};

type SkuStockType = {
  sku: string;
  name: string;
  context: string;
  inventory: number;
  minimumStock: number;
};

type LocationResponseType = {
  address: AddressLocationType;
  type: string;
  name: string;
  code: string;
};

type AddressLocationType = {
  cep: string;
  city: string;
  district: string;
  extra: string;
  number: string;
  state: string;
  street: string;
};

export function FinalizeOrder() {
  const navigate = useNavigate();
  const { pluginspace_id } = useParams();
  const { trackPurchase } = useFaceBookPixel();
  const { setOrderDataNFiscalL } = useFoodConfig();
  const { getToken, registerAccess, getThisPluginspace } = usePluginspace();
  const {
    getOrderAddress,
    getCustomer,
    getType,
    getCpfInNote,
    getPaymentType,
    getOrder,
    getTotalValue,
    getTotalValueWithoutDiscount,
    getFreight,
    getCard,
    getIntegrationPlan,
    generateDataToSendOrderCard,
    synchronizeContextToStorage,
    setReceipt,
    setOrderId,
    getGatewayId,
    setIntegrationPlan,
    setOrderIdExt,
    getLocationId,
    setObservation,
    observation,
    getGuidCartPayment,
    getDiscountGeneral,
    getSellerCpfCnpj,
    getServiceTaxes,
    clearOrder,
    setServiceTaxes,
    dencryptOrderStorage,
    encryptOrderStorage,
  } = useOrder();

  const {
    isInternalDelivery,
    isLandmark,
    tableNumber,
    tableName,
    cardName,
    counterNumber,
    internalDeliveryNumber,
    internalDeliveryName,
    landMarkNumber,
  } = useFoodConfig();
  const { getAppConfig } = useAppConfig();
  const { organizeFractions } = useProduct();
  const { pluginspaceData } = usePluginspace();
  const { validateAndCleanCart } = useFoodCartVisibilityValidation();
  const [config, setConfig] = useState<ConfigType | void>();
  const [loading, setLoading] = useState(true);
  const [orderAddress, setOrderAddress] = useState<OrderAddress>();
  const [customer, setCustomer] = useState<CustomerType>();
  const [type, setType] = useState("");
  const [cpfInNote, setCpfInNote] = useState("");
  const [paymentType, setPaymentType] = useState("");
  const [order, setOrder] = useState<OrderType>();
  const [total, setTotal] = useState(0);
  const [totalWithoutDiscount, setTotalWithoutDiscount] = useState(0);
  const [freight, setFreight] = useState(0);
  const [serviceTaxesNow, setServiceTaxesNow] = useState(0);
  const [card, setCard] = useState<CardType>();
  const [haveGuid, setHaveGuid] = useState(false);
  const [internalDelivery, setInternalDelivery] = useState("");

  const [integrationPlanLocal, setIntegrationPlanLocal] =
    useState<OrderIntegrationPlanType>();

  const [modalIsOpen, setModalIsOpen] = useState(false);

  const [paymentMethod, setPaymentMethod] = useState<JSX.Element | undefined>();
  const [uuid, setUuid] = useState("");
  const [errorInfo, setErrorInfo] = useState("");

  // para o cliente vindo do link de pagamento
  const [useWpp, setUseWpp] = useState(false);
  const [openTerms, setOpenTerms] = useState(false);
  const [acceptTerm, setAcceptTerm] = useState(false);
  const [term, setTerm] = useState("");

  const [validShift, setValidShift] = useState(true);

  const [openModalFinalizaVendaFood, setOpenModalFinalizaVendaFood] =
    useState(false);
  const [typeModal, setTypeModal] = useState<
    "process" | "error_payment" | "error_payment_totvs" | "error_connection"
  >("process");

  const [loadingHeader, setLoadingHeader] = useState(true);
  const [sellerInfo, setSellerInfo] = useState<any>(null);
  const [retirarServico, setRetirarServico] = useState(false);

  const { cardNumber, isTable, isCard, isCounter } = useFoodConfig();

  const [location, setLocation] = useState("");

  useEffect(() => {
    registerAccess("finalize-order");
    getConfig();
    const internalDeliveryNumber = localStorage.getItem("internal_number");
    const internalDeliveryName = localStorage.getItem("internal_name");
    if (internalDeliveryNumber && internalDeliveryName)
      setInternalDelivery(
        `${window.atob(internalDeliveryName)} ${window.atob(
          internalDeliveryNumber
        )}`
      );
  }, []);

  async function loadOrder() {
    localStorage.removeItem("qrcodePixPayment");
    await synchronizeContextToStorage();
    const cpfInNoteStorage = await getCpfInNote();
    const paymentTypeStorage = await getPaymentType();
    const orderAddressStorage = await getOrderAddress();
    const customerStorage = await getCustomer();
    const typeStorage = await getType();
    const orderStorage = await getOrder();
    const totalValue = await getTotalValue();
    const totalValueWithoutDiscount = await getTotalValueWithoutDiscount();
    const freightStorage = await getFreight();
    const serviceTaxesStorage = await getServiceTaxes();
    const cardStorage = await getCard();
    const integrationPlanStorage = await getIntegrationPlan();

    const guidCart = await getGuidCartPayment();

    setHaveGuid(guidCart);

    showPaymentMethod(paymentTypeStorage);
    setLocation(await findLocation(typeStorage));
    setOrderAddress(orderAddressStorage);
    setCustomer(customerStorage);
    setType(typeStorage);
    setCpfInNote(cpfInNoteStorage);
    setPaymentType(paymentTypeStorage);
    setOrder(orderStorage);
    setTotal(totalValue);
    setTotalWithoutDiscount(totalValueWithoutDiscount);
    setFreight(freightStorage);
    setServiceTaxesNow(serviceTaxesStorage);
    setCard(cardStorage);
    setIntegrationPlanLocal(integrationPlanStorage);
    setUuid(uuidv4());
  }

  async function getConfig() {
    setLoading(true);
    await getVerifyShift();
    await getSellerInfo();
    setLoadingHeader(true);
    setConfig(await getAppConfig());
    setLoadingHeader(false);
    await loadOrder();
    await validateAndCleanCart();
    await loadOrder();
    await getTerms();
    setLoading(false);
  }

  async function findLocation(type: string) {
    return await api
      .get(`/api/location`, {
        headers: {
          Authorization: `Bearer ${await getToken()}`,
        },
      })
      .then(async (response) => {
        const location = response.data.data.find(
          (location: LocationResponseType) => location.code == type
        );
        return location ? location.name : "Entrega";
      })
      .catch((err) => {
        console.log(err);
        return "Entrega";
      });
  }

  async function getSellerInfo() {
    const sellerCPF = await getSellerCpfCnpj();

    if (sellerCPF) {
      await api
        .post(
          "api/users/seller",
          {
            cpf: sellerCPF,
          },

          {
            headers: {
              Authorization: `Bearer ${await getToken()}`,
            },
          }
        )
        .then(async (response) => {
          setSellerInfo(response.data.data[0]);
        })
        .catch((err) => {
          console.log(err);
          Swal.fire({
            icon: "error",
            title: "Erro",
            text: "Erro ao encontrar loja",
          });
        });
    }
  }

  async function setTokenizedCard(response: any) {
    if (response.tokenizedPan) {
      setLoading(true);
      const cardTotvs: CardTotvsType = {
        amount: floatToCents(total) + floatToCents(freight),
        deliveryfee: floatToCents(freight),
        brand: response.brand,
        cardholderName: card?.name ? card?.name : "",
        cardNumber: null,
        expirationMonth: card?.month ? card?.month : "",
        expirationYear: card?.year ? card.year : "",
        installments: card?.installments ? card.installments : 1,
        nameCardBrand: response.brandName,
        securityCode: card?.cvv ? card.cvv : "",
        tokenizedPan: response.tokenizedPan,
        fingerprintSessionId: response.fingerprintSessionId,
      };
      const encryptedData = await generateGatewayCardTotvs(cardTotvs);
      const customerStorage = await getCustomer();
      const orderData: OrderToSendType | undefined =
        await generateDataToSendOrderCard(
          customerStorage,
          encryptedData,
          uuid,
          retirarServico,
          false,
          false,
          cardNumber
        );
      if (orderData) {
        const resultStock = await verifyStock(orderData);
        if (resultStock) {
          const shouldChangeOrderAddress = localStorage.getItem(
            "shouldChangeAddressFashion"
          );
          if (shouldChangeOrderAddress && Boolean(shouldChangeOrderAddress)) {
            orderData.orderAddress!.cep = "00000001";
          }

          const resultPayment = await makePayment(orderData);
          setLoading(false);
          if (resultPayment && resultPayment.success === true) {
            trackPurchase(orderData.totalAmountOrder);
            if (resultPayment.tablePayment || orderData.isCounter) {
              let type = resultPayment.tablePayment ? "table" : "card";
              let orderId = "";
              let number = 0;
              if (orderData.isCounter) {
                orderId = resultPayment.dados.orderidExt;
                type = "counter";
              }

              if (resultPayment.tablePayment) {
                number = resultPayment.tablePayment;
              }
              localStorage.setItem("customerName", customer!.name);
              const productsString = JSON.stringify(order!.products);
              localStorage.setItem("productsString", productsString);
              await synchronizeContextToStorage();
              clearOrder();
              setOrderDataNFiscalL({
                orderType: type as "table" | "card" | "counter",
                orderId: orderId,
                number: number,
              });
              navigate(`/${pluginspace_id}/success_order_food`);

              return;
            } else {
              setOrderId(resultPayment.dados.orderId);
              setOrderIdExt(resultPayment.dados.orderidExt);
              setReceipt(resultPayment.dados.customerReceipt.customer_receipt);

              await goToOrderInfo();
            }
          } else {
            setLoading(false);
            Swal.fire({
              icon: "error",
              title: "Erro",
              text:
                resultPayment &&
                resultPayment.message &&
                typeof resultPayment.message === "string"
                  ? resultPayment.message
                  : "Não foi possível finalizar sua compra",
            });
          }
        }
      } else {
        setLoading(false);
        Swal.fire({
          icon: "error",
          title: "Não foi possível finalizar sua compra",
          text: "Erro na integração com a TOTVS",
        });
      }
    } else {
      setLoading(false);
      Swal.fire({
        icon: "error",
        title: "Erro",
        text: "Não foi possível finalizar sua compra",
      });
    }
  }

  async function goToOrderInfo() {
    await synchronizeContextToStorage();
    clearOrder();
    navigate(`/${pluginspace_id}/success-order`);
  }

  async function totvsEncrypt() {
    const gatewayIdStorage = await getGatewayId();
    if (gatewayIdStorage) {
      return await api
        .get(`/api/pluginconfig/${gatewayIdStorage}`, {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        })
        .then(async (response) => {
          const dataPlugin = response.data;
          const cardStorage = await getCard();
          if (
            cardStorage &&
            dataPlugin.data &&
            dataPlugin.data[0] &&
            dataPlugin.data[0].content
          ) {
            const configTotvs = dataPlugin.data[0].content;
            const tkData = await api.post(
              `/api/totvshub/accessTotvs`,
              {
                gatewayId: gatewayIdStorage,
                pluginspaceId: pluginspaceData?.id ? pluginspaceData?.id : 1,
              },
              {
                headers: {
                  Authorization: `Bearer ${await getToken()}`,
                },
              }
            );
            if (
              tkData.data &&
              tkData.data.success &&
              tkData.data.tokenData &&
              tkData.data.tokenData.access_token
            ) {
              // @ts-ignore
              clientData = {
                amount: floatToCents(total) + floatToCents(freight),
                currency: "BRL",
                cardType: "CreditCard",
                externalPosId: configTotvs.externalposid,
                externalBusinessUnitId: configTotvs.externalbusinessunitid,
                externalTransactionId: configTotvs.externaltransactionid,
                installments: parseInt(cardStorage.installments),
                card: {
                  expirationYear: cardStorage.year,
                  expirationMonth: cardStorage.month,
                  securityCode: cardStorage.cvv,
                  number: cardStorage.number,
                },
                getTokenInfoAPI: {
                  // 		uri: 'https://dev.raas.varejo.totvs.com.br/pay-hub/transacting/card/api/payment-data',
                  uri: configTotvs.urlGetPaymentData,
                  token: tkData.data.tokenData.access_token,
                },
              };
              // const access_token = "eyJhbGciOiJSUzI1NiIsImtpZCI6IjJiYjZmYzUyM2ZjNzQwZjI4NmMxOTZmY2ExMzUyNzE2IiwidHlwIjoiSldUIn0.eyJuYmYiOjE2NjkwMzIwMDYsImV4cCI6MTY2OTExODQwNiwiaXNzIjoiaHR0cHM6Ly90b3R2c3JhYXMucmFjLmRldi50b3R2cy5hcHAvdG90dnMucmFjIiwiYXVkIjoiYXV0aG9yaXphdGlvbl9hcGkiLCJjbGllbnRfaWQiOiJwYXltZW50aHViX2JkYjc1NDBhODgwNjQwNDQ5ODBiYzFhMmUyZGQxZDA3X3JvIiwic3ViIjoiMzQyODEiLCJhdXRoX3RpbWUiOjE2NjkwMzIwMDYsImlkcCI6ImxvY2FsIiwiaHR0cDovL3d3dy50bmYuY29tL2lkZW50aXR5L2NsYWltcy9wcm9kdWN0SWQiOiIzNyIsImh0dHA6Ly93d3cudG5mLmNvbS9pZGVudGl0eS9jbGFpbXMvcHJvZHVjdE5hbWUiOiJUb3R2cyBSYWFTIFBheW1lbnQgSHViIiwiaHR0cDovL3d3dy50bmYuY29tL2lkZW50aXR5L2NsYWltcy9yYWNWZXJzaW9uIjoiMS4yOC41NS4wIiwiaHR0cDovL3d3dy50bmYuY29tL2lkZW50aXR5L2NsYWltcy9wcm9kdWN0Um9sZSI6WyJSZWZ1bmRBY2Nlc3NvclVzZXIiLCJSYWFzQWRtaW4iLCJQYXltZW50QWRtaW4iLCJST0FjY2Vzc29yVXNlciIsIkFkbWluIiwiUmVwb3J0UmVhZGVyIl0sInJvbGUiOlsiUmFhcyBwYXltZW50IGNvbmZpZ3VyaW5nIiwiQ2FkYXN0cm8gZGUgUGVyZmlsIl0sImh0dHA6Ly93d3cudG5mLmNvbS9pZGVudGl0eS9jbGFpbXMvY3VzdG9tUm9sZSI6WyJSYWFzUGF5bWVudENvbmZpZ3VyaW5nIiwiQ2FkYXN0cm9EZVBlcmZpbCJdLCJodHRwOi8vd3d3LnRuZi5jb20vaWRlbnRpdHkvY2xhaW1zL3RlbmFudElkIjoiOTgxZGQ0ZTgtMzI0My00Mjc0LWE0MjUtMDcyMDMzYTlkOTcxIiwiaHR0cDovL3d3dy50bmYuY29tL2lkZW50aXR5L2NsYWltcy90ZW5hbnROYW1lIjoidG90dnNyYWFzIiwiaHR0cDovL3d3dy50bmYuY29tL2lkZW50aXR5L2NsYWltcy90ZW5hbnRGdWxsTmFtZSI6IlRvdHZzIFJhYVMiLCJodHRwOi8vd3d3LnRuZi5jb20vaWRlbnRpdHkvY2xhaW1zL3RlbmFudElkTGVnYWN5IjoiODEiLCJodHRwOi8vd3d3LnRuZi5jb20vaWRlbnRpdHkvY2xhaW1zL3VzZXJGdWxsbmFtZSI6IkFsZXNzYW5kbyBCb3JnZXMiLCJuYW1lIjpbImFsZXNzYW5kcm9BU0JAZ21haWwuY29tIiwiQWxlc3NhbmRvIEJvcmdlcyJdLCJlbWFpbCI6ImFsZXNzYW5kcm9hc2JAZ21haWwuY29tIiwiaWF0IjoxNjY5MDMyMDA2LCJzY29wZSI6WyJhdXRob3JpemF0aW9uX2FwaSJdLCJhbXIiOlsicHdkIl19.HzH9zIhQM4OVZ77MKJNuRlHHtp6n1FDFp7kfm6f2Md0f7DjQFBpobFFOM2oKnWp0gafhesDtvClJ7QjB_LnJy37XuYAAchiNk-IzhXC5UGs0nb7hMOfiPuzhm0FCqNgTtedZkI9jpFg4LCzShopLmBNqG3VHq0PDaaAoTBu8ojl9iHQrzaRSaoyDLVj562Hco83Bq8I6w5hFMRcQ99nVd16as2wkEcQqcBNYNUtsyS0gTllu66PGdpXpEwQu2obXHBjG1eKAYbU-I2gAbXqQy39-nk_lfEvnQgpeyzuwwRQhM6ue2JuyhP1bkrVfA9rCxFChlE8Ks_Gwrw3YRsVxbA"
              // // @ts-ignore
              // clientData = {
              // 	amount: "150",
              // 	currency: "BRL",
              // 	cardType: "CreditCard",
              // 	externalPosId: "carnaval",
              // 	externalBusinessUnitId: "491",
              // 	installments: 3,
              // 	card: {
              // 		expirationYear: '2022',
              // 		expirationMonth: '12',
              // 		securityCode: '838',
              // 		brand: '',
              // 		number: '4622943127013705',
              // 	},
              // 	getTokenInfoAPI: {
              // 		uri: 'https://dev.raas.varejo.totvs.com.br/pay-hub/transacting/card/api/payment-data',
              // 		token: access_token,
              // 	}
              // }

              // @ts-ignore
              getTokenizedCardPan(clientData, setTokenizedCard);
            } else {
              setLoading(false);
              Swal.fire({
                icon: "error",
                title: "Erro",
                text: "Não foi possível finalizar sua compra",
              });
              return null;
            }
          } else {
            setLoading(false);
            Swal.fire({
              icon: "error",
              title: "Erro",
              text: "Não foi possível finalizar sua compra",
            });
            return null;
          }
        })
        .catch((err) => {
          setLoading(false);
          Swal.fire({
            icon: "error",
            title: "Erro",
            text: "Não foi possível finalizar sua compra",
          });
          return null;
        });
    } else {
      setLoading(false);
      Swal.fire({
        icon: "error",
        title: "Erro",
        text: "Não foi possível finalizar sua compra",
      });
      return null;
    }
  }

  async function pagseguroEncrypt() {
    return await api
      .get("/api/pagseguro/pagseguroPublicKey", {
        headers: {
          Authorization: `Bearer ${await getToken()}`,
        },
      })
      .then(async (response) => {
        const cardStorage = await getCard();
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const encryptedCard = PagSeguro.encryptCard({
          publicKey: response.data.publicKey,
          holder: cardStorage.name,
          number: cardStorage.number,
          expMonth: cardStorage.month,
          expYear: cardStorage.year,
          securityCode: cardStorage.cvv,
        });
        return encryptedCard;
      })
      .catch((err) => {
        console.log(err);
        return null;
      });
  }

  function showPaymentMethod(typeStorage: string) {
    switch (typeStorage) {
      case "esitef-card":
        setPaymentMethod(<></>);
        break;
      // case 'cielo-card':
      //     setPaymentMethod(
      //         <div className="option">
      //             <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      //                 <path d="M16.577 15.0686C15.8016 14.3925 15.0545 13.74 14.298 13.0828C15.3855 11.6738 15.8205 10.0993 15.5132 8.34991C15.272 6.9693 14.5912 5.83928 13.5226 4.92675C11.5037 3.20098 7.93396 3.02131 5.69755 5.58869C4.95523 4.93148 4.20819 4.28372 3.4375 3.6076C5.46114 1.39011 7.93396 0.293179 10.9032 0.661973C14.5723 1.11587 17.0309 3.20571 18.1704 6.6998C19.1538 9.72107 18.5202 12.5201 16.577 15.0686Z" fill="#204987"/>
      //                 <path d="M3.42308 3.59818C4.1985 4.2743 4.94554 4.92678 5.70204 5.58399C4.61457 6.99298 4.17958 8.56744 4.48691 10.3169C4.72805 11.6975 5.4089 12.8275 6.47746 13.74C8.49637 15.4658 12.0661 15.6455 14.3025 13.0781C15.0496 13.7306 15.7966 14.3783 16.5673 15.0544C14.5436 17.2719 12.0708 18.3689 9.10157 18.0001C5.42781 17.5462 2.96918 15.4611 1.8297 11.967C0.846251 8.94097 1.47982 6.14191 3.42308 3.59818Z" fill="#27ABE3"/>
      //             </svg>
      //             <p>Cielo</p>
      //         </div>
      //     );
      //     break;
      // case 'pagseguro-card':
      //     setPaymentMethod(
      //         <div className="option">
      //             <img src={PagseguroImg} alt="Pagseguro" />
      //             <p>Pagseguro</p>
      //         </div>
      //     )
      //     break;
      // case 'rede-card':
      //     setPaymentMethod(
      //         <div className="option">
      //             <img src={RedeCardImg} alt="RedeCard" />
      //             <p>Redecard</p>
      //         </div>
      //     );
      //     break;
      case "pix":
        setPaymentMethod(
          <div className="option">
            <img src={PixImg} alt="Pix" />
            <p>Pix</p>
          </div>
        );
        break;
      default:
        break;
    }
  }

  async function generateNameBrand(codePayCard: string) {
    try {
      const resPluginspace = await api.get("/api/pluginspace/this", {
        headers: {
          Authorization: `Bearer ${await getToken()}`,
        },
      });
      if (
        resPluginspace.data.data &&
        resPluginspace.data.data[0] &&
        resPluginspace.data.data[0].hash
      ) {
        const resIntegration = await api.post(
          "api/orders/card-payment-get",
          {
            hash: resPluginspace.data.data[0].hash,
          },
          {
            headers: {
              Authorization: `Bearer ${await getToken()}`,
            },
          }
        );
        const cardFind = resIntegration.data.data.data.find(
          (integration: IntegrationType) => integration.codePay === codePayCard
        );
        if (cardFind) {
          return cardFind.brand;
        } else {
          return "";
        }
      }
      return "";
    } catch (e) {
      console.log(e);
      return "";
    }
  }

  async function generateCodePayPlanDelivery() {
    try {
      const resPluginspace = await api.get("/api/pluginspace/this", {
        headers: {
          Authorization: `Bearer ${await getToken()}`,
        },
      });
      if (
        resPluginspace.data.data &&
        resPluginspace.data.data[0] &&
        resPluginspace.data.data[0].hash
      ) {
        const resIntegration = await api.post(
          "api/orders/card-payment-get",
          {
            hash: resPluginspace.data.data[0].hash,
          },
          {
            headers: {
              Authorization: `Bearer ${await getToken()}`,
            },
          }
        );
        const gatewayIdStorage = await getGatewayId();
        const newBrandsIntegrations: IntegrationType[] =
          resIntegration.data.data.data.filter(
            (integration: IntegrationType) =>
              integration.pluginconfigId === gatewayIdStorage
          );
        setIntegrationPlan({
          codePay: integrationPlanLocal?.codePay
            ? integrationPlanLocal.codePay
            : newBrandsIntegrations[0].codePay,
          codePlan: integrationPlanLocal?.codePlan
            ? integrationPlanLocal.codePlan
            : newBrandsIntegrations[0].paymentPlans[0].codePlan,
          nameGateway: integrationPlanLocal?.nameGateway
            ? integrationPlanLocal.nameGateway
            : newBrandsIntegrations[0].nameGateway,
          nameBrand: integrationPlanLocal?.nameBrand
            ? integrationPlanLocal.nameBrand
            : newBrandsIntegrations[0].brand,
          typePayment: integrationPlanLocal?.typePayment,
        });
      }
      return "";
    } catch (e) {
      console.log(e);
      return "";
    }
  }

  async function generateGatewayDelivery() {
    await generateCodePayPlanDelivery();

    return await api
      .post(
        "/api/cryptography/encryptJson",
        {
          value: {
            amount: floatToCents(total) + floatToCents(freight),
            deliveryfee: floatToCents(freight),
            installments: 1,
            holderName: customer?.name ? customer?.name : "",
          },
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        }
      )
      .then((response) => {
        return response.data.data.encryptedData;
      })
      .catch((err) => {
        console.log(err);
        return null;
      });
  }

  async function generateQRCode() {
    try {
      setLoading(true);
      const locationId = await getLocationId();
      const orderStorage = await getOrder();
      const orderSend: any = {
        locationId: locationId,
        products: orderStorage.products.map((p) => ({
          productSku: p.sku,
          quantity: p.quantity,
        })),
      };
      const resultStock = await verifyStock(orderSend);
      if (resultStock) {
        const gatewayId = await getGatewayId();
        const gatewayResponse = await api.get(`api/pluginconfig/${gatewayId}`, {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        });
        const plugintemplate =
          gatewayResponse.data.data[0] &&
          gatewayResponse.data.data[0].plugintemplateId
            ? gatewayResponse.data.data[0].plugintemplateId
            : 0;
        const resPluginspace = await api.get("api/pluginspace/this", {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        });
        if (
          resPluginspace.data.data &&
          resPluginspace.data.data[0] &&
          resPluginspace.data.data[0].hash
        ) {
          const resIntegration = await api.post(
            "api/orders/card-payment-get",
            {
              hash: resPluginspace.data.data[0].hash,
            },
            {
              headers: {
                Authorization: `Bearer ${await getToken()}`,
              },
            }
          );
          const newBrandsIntegrations: IntegrationType[] =
            resIntegration.data.data.data.filter(
              (integration: IntegrationType) =>
                integration.pluginconfigId === gatewayId &&
                integration.brand === "Pix"
            );
          if (newBrandsIntegrations[0]) {
            setIntegrationPlan({
              codePay: newBrandsIntegrations[0].codePay,
              codePlan: newBrandsIntegrations[0].paymentPlans[0].codePlan,
              nameGateway: newBrandsIntegrations[0].nameGateway,
              nameBrand: "pix",
              typePayment: "pix",
            });
            if (retirarServico) setServiceTaxes(0);
            setLoading(false);
            navigate(`/${pluginspace_id}/order-qrcode`);
          } else {
            setLoading(false);
            Swal.fire({
              icon: "error",
              title: "Erro!",
              text: `Não foi possível achar meio de pagamento cadastrado`,
            });
            return;
          }
        }
        setLoading(false);
        navigate(`/${pluginspace_id}/order-qrcode`);
      }
    } catch (e) {
      setLoading(false);
      navigate(`/${pluginspace_id}/order-qrcode`);
      console.log(e);
    }
  }

  async function generateGatewayCardTotvs(cardTotvs: CardTotvsType) {
    return await api
      .post(
        "api/cryptography/encryptJson",
        {
          value: cardTotvs,
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        }
      )
      .then((response) => {
        return response.data.data.encryptedData;
      })
      .catch((err) => {
        console.log(err);
        return null;
      });
  }

  async function generateGatewayCardGeral() {
    let nameCardBrand = "";
    const cardStorage = await getCard();

    nameCardBrand = await generateNameBrand(cardStorage.brand);
    return await api
      .post(
        "/api/cryptography/encryptJson",
        {
          value: {
            amount: floatToCents(total) + floatToCents(freight),
            cardBrand: cardStorage.brand.toString(),
            deliveryfee: floatToCents(freight),
            installments:
              cardStorage.installments !== undefined
                ? parseInt(cardStorage.installments)
                : cardStorage.installments,
            nameCardBrand: nameCardBrand
              ? nameCardBrand
              : cardStorage.brand.toString(),
            cardholderName: cardStorage.name,
            cardNumber: cardStorage.number,
            securityCode: cardStorage.cvv,
            expirationMonth:
              cardStorage.month !== undefined
                ? parseInt(cardStorage.month)
                : cardStorage.month,
            expirationYear:
              cardStorage.year !== undefined
                ? parseInt(cardStorage.year)
                : cardStorage.year,
          },
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        }
      )
      .then((response) => {
        return response.data.data.encryptedData;
      })
      .catch((err) => {
        console.log(err);
        return null;
      });
  }

  async function generateGatewayCardPagseguro(encryptedCard: string) {
    const cardStorage = await getCard();
    return await api
      .post(
        "/api/cryptography/encryptJson",
        {
          value: {
            amount: floatToCents(total) + floatToCents(freight),
            cardBrand: cardStorage.brand.includes("ECOMMERCE")
              ? "ECOMMERCE"
              : cardStorage.brand,
            deliveryfee: floatToCents(freight),
            installments: cardStorage.installments,
            nameCardBrand: cardStorage.brand.includes("ECOMMERCE")
              ? "ECOMMERCE"
              : cardStorage.brand,
            cardNumber: cardStorage.number,
            cardholderName: cardStorage.name,
            securityCode: cardStorage.cvv,
            expirationMonth: cardStorage.month,
            expirationYear: cardStorage.year,
            encryptedCard: encryptedCard,
          },
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        }
      )
      .then((response) => {
        return response.data.data.encryptedData;
      })
      .catch((err) => {
        console.log(err);
        return null;
      });
  }

  async function getVerifyShift() {
    try {
      const pgData = await getThisPluginspace();
      const response = await api.post(
        `api/location-operation/verify`,
        {},
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        }
      );

      if (pgData && pgData.type === "food") {
        setValidShift(response.data && response.data.success);
      } else {
        setValidShift(true);
      }
    } catch (error) {
      console.log(error);
    }
  }

  async function finalizeOrder() {
    if (!validShift) {
      Swal.fire({
        icon: "warning",
        title: "Atenção!",
        text: `A loja se encontra fechada e não está aceitando pedidos`,
      });
      return;
    }

    const isCartValid = await validateAndCleanCart();
    if (!isCartValid) {
      await loadOrder();
      return;
    }

    if (haveGuid) await updateCustomer();

    if (isTable || isCard || isCounter) {
      setOpenModalFinalizaVendaFood(true);
      setLoading(false);
    } else {
      setLoading(true);
    }

    switch (paymentType) {
      case "pagseguro-card":
        finalizeOrderPagseguro();
        break;
      case "rede-card":
        finalizeOrderGeralCard();
        break;
      case "cielo-card":
        finalizeOrderGeralCard();
        break;
      case "totvs-card":
        finalizeOrderTotvs();
        break;
      case "delivery-payment":
        finalizeOrderGeralDelivery();
        break;
    }
  }

  async function finalizeOrderTotvs() {
    setLoading(true);
    await totvsEncrypt();
    setTimeout(() => {
      if (loading) setLoading(false);
    }, 1000);
  }

  async function finalizeOrderPagseguro() {
    setLoading(true);
    const encryptedCard = await pagseguroEncrypt();
    if (encryptedCard.errors.length === 0 && customer !== undefined) {
      const encryptedData = await generateGatewayCardPagseguro(
        encryptedCard.encryptedCard
      );

      const orderData: OrderToSendType | undefined =
        await generateDataToSendOrderCard(
          customer,
          encryptedData,
          uuid,
          retirarServico,
          false,
          false,
          cardNumber
        );
      if (orderData) {
        const resultStock = await verifyStock(orderData);
        if (resultStock) {
          const shouldChangeOrderAddress = localStorage.getItem(
            "shouldChangeAddressFashion"
          );
          if (shouldChangeOrderAddress && Boolean(shouldChangeOrderAddress)) {
            orderData.orderAddress!.cep = "00000001";
          }

          const resultPayment = await makePayment(orderData);
          setLoading(false);
          if (resultPayment && resultPayment.success === true) {
            trackPurchase(orderData.totalAmountOrder);
            if (resultPayment.tablePayment || orderData.isCounter) {
              let type = resultPayment.tablePayment ? "table" : "card";
              let orderId = "";
              let number = 0;
              if (orderData.isCounter) {
                orderId = resultPayment.dados.orderidExt;
                type = "counter";
              }

              if (resultPayment.tablePayment) {
                number = resultPayment.tablePayment;
              }
              localStorage.setItem("customerName", customer!.name);
              const productsString = JSON.stringify(order!.products);
              localStorage.setItem("productsString", productsString);
              await synchronizeContextToStorage();
              clearOrder();
              setOrderDataNFiscalL({
                orderType: type as "table" | "card" | "counter",
                orderId: orderId,
                number: number,
              });
              navigate(`/${pluginspace_id}/success_order_food`);

              return;
            } else {
              setOrderId(resultPayment.dados.orderId);
              setOrderIdExt(resultPayment.dados.orderidExt);
              setReceipt(resultPayment.dados.customerReceipt.customer_receipt);

              await goToOrderInfo();
            }
          } else {
            Swal.fire({
              icon: "error",
              title: "Erro",
              text:
                resultPayment &&
                resultPayment.message &&
                typeof resultPayment.message === "string"
                  ? resultPayment.message
                  : "Não foi possível finalizar sua compra",
            });
          }
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "Erro",
          text: "Não foi possível finalizar sua compra",
        });
      }
    } else {
      setLoading(false);
      Swal.fire({
        icon: "error",
        title: "Erro",
        text: "Não foi possível finalizar sua compra",
      });
    }
  }

  async function finalizeOrderGeralDelivery() {
    setLoading(true);
    if (customer !== undefined) {
      const encryptedData = await generateGatewayDelivery();
      const orderData: OrderToSendType | undefined =
        await generateDataToSendOrderCard(
          customer,
          encryptedData,
          uuid,
          retirarServico,
          false,
          true,
          cardNumber
        );
      if (orderData) {
        const resultStock = await verifyStock(orderData);
        if (resultStock) {
          const shouldChangeOrderAddress = localStorage.getItem(
            "shouldChangeAddressFashion"
          );
          if (shouldChangeOrderAddress && Boolean(shouldChangeOrderAddress)) {
            orderData.orderAddress!.cep = "00000001";
          }

          const resultPayment = await makePayment(orderData);
          setLoading(false);
          if (resultPayment && resultPayment.success === true) {
            trackPurchase(orderData.totalAmountOrder);
            if (resultPayment.tablePayment || orderData.isCounter) {
              let type = resultPayment.tablePayment ? "table" : "card";
              let orderId = "";
              let number = 0;
              if (orderData.isCounter) {
                orderId = resultPayment.dados.orderidExt;
                type = "counter";
              }

              if (resultPayment.tablePayment) {
                number = resultPayment.tablePayment;
              }
              localStorage.setItem("customerName", customer!.name);
              const productsString = JSON.stringify(order!.products);
              localStorage.setItem("productsString", productsString);
              await synchronizeContextToStorage();
              clearOrder();
              setOrderDataNFiscalL({
                orderType: type as "table" | "card" | "counter",
                orderId: orderId,
                number: number,
              });
              navigate(`/${pluginspace_id}/success_order_food`);

              return;
            } else {
              setOrderId(resultPayment.dados.orderId);
              setOrderIdExt(resultPayment.dados.orderidExt);
              setReceipt(resultPayment.dados.customerReceipt.customer_receipt);
              goToOrderInfo();
            }
          } else {
            Swal.fire({
              icon: "error",
              title: "Erro",
              text:
                resultPayment &&
                resultPayment.message &&
                typeof resultPayment.message === "string"
                  ? resultPayment.message
                  : "Não foi possível finalizar sua compra",
            });
          }
        }
      } else {
        setLoading(false);
        Swal.fire({
          icon: "error",
          title: "Erro",
          text: "Não foi possível finalizar sua compra",
        });
      }
    } else {
      setLoading(false);
      Swal.fire({
        icon: "error",
        title: "Erro",
        text: "Não foi possível finalizar sua compra",
      });
    }
  }

  async function finalizeOrderGeralCard() {
    setLoading(true);

    if (customer !== undefined) {
      const encryptedData = await generateGatewayCardGeral();
      const orderData: OrderToSendType | undefined =
        await generateDataToSendOrderCard(
          customer,
          encryptedData,
          uuid,
          retirarServico,
          false,
          false,
          cardNumber
        );
      if (orderData) {
        const resultStock = await verifyStock(orderData);
        if (resultStock) {
          const shouldChangeOrderAddress = localStorage.getItem(
            "shouldChangeAddressFashion"
          );
          if (shouldChangeOrderAddress && Boolean(shouldChangeOrderAddress)) {
            orderData.orderAddress!.cep = "00000001";
          }

          const resultPayment = await makePayment(orderData);
          setLoading(false);
          if (resultPayment && resultPayment.success === true) {
            trackPurchase(orderData.totalAmountOrder);
            if (resultPayment.tablePayment || orderData.isCounter) {
              let type = resultPayment.tablePayment ? "table" : "card";
              let orderId = "";
              let number = 0;
              if (orderData.isCounter) {
                orderId = resultPayment.dados.orderidExt;
                type = "counter";
              }

              if (resultPayment.tablePayment) {
                number = resultPayment.data.table;
              }
              localStorage.setItem("customerName", customer!.name);
              const productsString = JSON.stringify(order!.products);
              localStorage.setItem("productsString", productsString);
              await synchronizeContextToStorage();
              clearOrder();
              setOrderDataNFiscalL({
                orderType: type as "table" | "card" | "counter",
                orderId: orderId,
                number: number,
              });
              navigate(`/${pluginspace_id}/success_order_food`);

              return;
            } else {
              setOrderId(resultPayment.dados.orderId);
              setOrderIdExt(resultPayment.dados.orderidExt);
              setReceipt(resultPayment.dados.customerReceipt.customer_receipt);

              await goToOrderInfo();
            }
          } else {
            // nova validação , caso seja pagamento de mesa/comanda balcao:
            if (!resultPayment.success && orderData.tablePayment) {
              if (resultPayment.code) {
                setTypeModal("error_payment");
                return;
              }
              setTypeModal("error_payment_totvs");
              return;
            }

            if (!resultPayment.success && resultPayment.typemsg === "info") {
              Swal.fire({
                icon: "info",
                title: "Aviso",
                text:
                  resultPayment &&
                  resultPayment.message &&
                  typeof resultPayment.message === "string"
                    ? resultPayment.message
                    : "Seu pedido está sendo processado e encontra-se em análise",
              }).then(async () => {
                //Caso mude o fluxo, retirar isso.

                setOrderId(resultPayment.dados.orderId);
                setOrderIdExt(resultPayment.dados.orderidExt);
                setReceipt(
                  resultPayment.dados.customerReceipt.customer_receipt
                );

                await goToOrderInfo();
              });
            } else {
              Swal.fire({
                icon: "error",
                title: "Erro",
                text:
                  resultPayment &&
                  resultPayment.message &&
                  typeof resultPayment.message === "string"
                    ? resultPayment.message
                    : "Não foi possível finalizar sua compra",
              });
            }
          }
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "Erro",
          text: "Não foi possível finalizar sua compra",
        });
      }
    } else {
      setLoading(false);
      Swal.fire({
        icon: "error",
        title: "Erro",
        text: "Não foi possível finalizar sua compra",
      });
    }
  }

  async function makePayment(orderData: OrderToSendType, attempts: number = 1) {
    const orderSend = orderData;
    let landmarkItem = await getLandmark();
    if (landmarkItem) {
      orderSend.landmarkSynkar = landmarkItem.interval;
      orderSend.landmarkSynkarName = landmarkItem.landmark;
    }
    let landmarkPluginbotItem = await getLandmarkPluginbot();
    if (landmarkPluginbotItem) {
      orderSend.landmarkPluginbot = landmarkPluginbotItem.interval;
      orderSend.landmarkPluginbotName = landmarkPluginbotItem.landmark;
    }
    orderSend.urlNotification = window.location.href.replace(
      "order-finalize",
      "success-order"
    );

    // Attempt to attach only the minimal hotelContext (customer.doc, id, room.id)
    const pickHotelFields = (ctx: any) => {
      if (!ctx || typeof ctx !== "object") return undefined;
      const out: any = {};
      if (ctx.id) out.id = ctx.id;
      if (ctx.customer && ctx.customer.doc)
        out.customer = { doc: ctx.customer.doc };
      if (!out.customer && (ctx.customer_doc || ctx.customerDoc)) {
        out.customer = { doc: ctx.customer_doc || ctx.customerDoc };
      }
      if (ctx.room && ctx.room.id) out.room = { id: ctx.room.id };
      if (!out.room && (ctx.roomId || ctx.room_id)) {
        out.room = { id: ctx.roomId || ctx.room_id };
      }
      return Object.keys(out).length > 0 ? out : undefined;
    };

    // Use sessionStorage only (server endpoint removed per new decision)
    try {
      const stored = sessionStorage.getItem("hotelReservationContext");
      if (stored) {
        const parsed = JSON.parse(stored);
        const raw = Array.isArray(parsed) ? parsed[0] : parsed;

        // Verificar se é contexto view-only (não deve ser enviado ao backend)
        if (raw.viewOnly === true) {
          console.log(
            "Hotel context is view-only, skipping backend submission"
          );
        } else {
          const normalized: any = {};
          if (raw.reservationId) normalized.id = raw.reservationId;
          if (raw.id) normalized.id = normalized.id || raw.id;
          const doc =
            raw.doc ||
            raw.customer?.doc ||
            raw.customer_doc ||
            raw.customerDoc ||
            raw.cpf;
          if (doc) normalized.customer = { doc };
          const roomId = raw.roomId || raw.room?.id || raw.room_id;
          if (roomId) normalized.room = { id: roomId };

          // create flat shape { id, doc, roomId }
          const flat: any = {};
          if (normalized.id) flat.id = normalized.id;
          if (normalized.customer && normalized.customer.doc)
            flat.doc = normalized.customer.doc;
          if (normalized.room && normalized.room.id)
            flat.roomId = normalized.room.id;

          // attach pluginspaceId if present in stored raw context
          const pluginspaceId =
            raw.pluginspaceId ||
            raw.pluginspace_id ||
            raw.pluginspace ||
            raw.father;
          if (pluginspaceId) flat.pluginspaceId = pluginspaceId;

          if (Object.keys(flat).length > 0) orderSend.hotelContext = flat;
        }
      }
    } catch (e) {
      console.warn(
        "Could not parse hotelReservationContext from sessionStorage",
        e
      );
    }

    return await api
      .post("/api/orders/sendOrder", orderSend, {
        headers: {
          Authorization: `Bearer ${await getToken()}`,
        },
      })
      .then((response) => {
        setOpenModalFinalizaVendaFood(false);
        return response.data;
      })
      .catch(async (err) => {
        const erro = err.response ? err.response.data : null;

        if (
          erro &&
          arrayMessagesConnectionTotvs.includes(erro.message.trim())
        ) {
          err.response.data.message =
            "Não foi possível enviar o seu pedido, por favor dirija-se ao caixa.";
          if (attempts < 3) {
            if (attempts === 1) {
              setLoading(false);
              setOpenModalFinalizaVendaFood(true);
              setTypeModal("error_connection");
            }
            await new Promise((resolve, reject) => setTimeout(resolve, 5000));
            const responsePayment: any = await makePayment(
              orderData,
              attempts + 1
            );
            if (responsePayment && responsePayment.success) {
              setOpenModalFinalizaVendaFood(false);
              return responsePayment;
            }
          } else {
            setOpenModalFinalizaVendaFood(false);
          }
        } else if (
          erro &&
          arrayMessagesPaymentCard.find(
            (ms) => ms.message.toUpperCase() === erro.message.toUpperCase()
          )
        ) {
          const errorMessage = arrayMessagesPaymentCard.find(
            (ms) => ms.message.toUpperCase() === erro.message.toUpperCase()
          );
          setOpenModalFinalizaVendaFood(true);
          setTypeModal("error_payment");
          setErrorInfo(errorMessage ? errorMessage.translated : "");
          return erro;
        } else {
          setOpenModalFinalizaVendaFood(true);
          setTypeModal("error_connection");
          setErrorInfo(
            erro
              ? erro.message
              : "Não foi possível enviar o seu pedido, por favor dirija-se ao caixa."
          );
        }
        return erro;
      });
  }

  async function verifyStock(orderData: OrderToSendType) {
    const pgData = await getThisPluginspace();
    if (config && !config.content.pdv.showOutStock) {
      return await api
        .post(
          `/api/variations/sku-inventory?order=ASC&page=${1}&take=${5000}`,
          {
            skus: orderData.products.map((product) => product.productSku),
            locationId: orderData.locationId,
            status: true,
          },
          {
            headers: {
              Authorization: `Bearer ${await getToken()}`,
            },
          }
        )
        .then((response) => {
          const items = response.data;
          if (items.data) {
            let productsEmpty: SkuStockType[] = [];
            items.data.forEach((item: SkuStockType) => {
              const prod = orderData.products.find(
                (product) => product.productSku === item.sku
              );
              if (
                prod?.quantity &&
                item.inventory - item.minimumStock < prod.quantity
              ) {
                productsEmpty.push(item);
              }
            });
            if (productsEmpty && productsEmpty.length > 0) {
              setLoading(false);
              let textSwal = "";
              productsEmpty.forEach((product: SkuStockType) => {
                textSwal += `Produto: ${product.name} sem estoque<br/>`;
              });
              Swal.fire({
                icon: "warning",
                html: textSwal,
              });
              return false;
            }
            return true;
          } else {
            setLoading(false);
            Swal.fire({
              icon: "error",
              title: "Erro",
              text: "Não foi possível obter estoque dos produtos",
            });
          }
        })
        .catch((err) => {
          setLoading(false);
          Swal.fire({
            icon: "error",
            title: "Erro",
            text: "Não foi possível obter estoque dos produtos",
          });
        });
    } else {
      return true;
    }
  }

  // Termos de consentimento

  async function getTermsTotvs() {
    return await api
      .get(`/api/letter-consent`, {
        headers: {
          Authorization: `Bearer ${await getToken()}`,
        },
      })
      .then(async (response) => {
        const totvsRes = response.data;
        if (totvsRes && totvsRes.data && totvsRes.data.body) {
          setTerm(rtcToText(totvsRes.data.body));
          return true;
        } else {
          return false;
        }
      })
      .catch((err) => {
        return false;
      });
  }

  async function getTerms() {
    const hasTotvsTerms = await getTermsTotvs();
    if (!hasTotvsTerms) {
      await api
        .post(
          `/api/consent/filter`,
          {
            active: true,
          },
          {
            headers: {
              Authorization: `Bearer ${await getToken()}`,
            },
          }
        )
        .then(async (response) => {
          setTerm(response.data.data[0].content);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }

  function readTerms() {
    setOpenTerms(true);
  }
  // update de cliente com webApp e consentimento
  async function updateCustomer() {
    let customerBack: any = {};
    await api
      .post(
        `/api/customer/filter`,
        {
          cpf: customer!.cpf,
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        }
      )
      .then(async (response) => {
        if (response.data.data.length > 0) {
          customerBack = response.data.data[0];
        }
      })
      .catch((err) => {
        console.log(err);
      });

    const customerToSend = {
      name: customer!.name,
      email: customer!.email,
      doc: cpfCnpjNoMask(customer!.cpf),
      cpf: cpfCnpjNoMask(customer!.cpf),
      optinWhatsapp: useWpp ? true : false,
      lgpdDataAceiteCarta: new Date(),
      addresses: [
        {
          zipCode: customerBack.customerAddresses[0].zipCode,
          street: customerBack.customerAddresses[0].address,
          number: customerBack.customerAddresses[0].number,
          district: customerBack.customerAddresses[0].district,
          city: customerBack.customerAddresses[0].city,
          state: customerBack.customerAddresses[0].state,
          extra: customerBack.customerAddresses[0].complement,
          reference: "",
          typeAddress: "main",
          ibge: customerBack.customerAddresses[0].ibge,
        },
      ],
    };

    await api
      .post(`/api/customer`, customerToSend, {
        headers: {
          Authorization: `Bearer ${await getToken()}`,
        },
      })
      .then((response) => {
        if (response.data.success === true) {
          return true;
        }
        // } else {
        // 	setLoading(false);
        // 	Swal.fire({
        // 		icon: "error",
        // 		title: "Erro!",
        // 		text: "Um erro ocorreu, tente novamente",
        // 	});
        // }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const getLandmark = () => {
    const landmark = localStorage.getItem("landmark_synkar");
    if (landmark) {
      const landmarkItem = JSON.parse(window.atob(landmark));
      return landmarkItem;
    } else {
      return null;
    }
  };

  const getLandmarkPluginbot = () => {
    const landmark = localStorage.getItem("landmark_pluginbot");
    if (landmark) {
      const landmarkItem = JSON.parse(window.atob(landmark));
      return landmarkItem;
    } else {
      return null;
    }
  };

  function chooseModality() {
    switch (type) {
      case "withdraw":
        return "Retirada";
      case "delivery":
        return "Entrega";
      case "table":
        // ✅ MOSTRAR NÚMERO DA MESA
        if (isTable && tableNumber) {
          return `Mesa - ${tableNumber}`;
        }
        return "Mesa";
      case "card":
        if (isCard && cardNumber) {
          return `Comanda - ${cardNumber}`;
        }
        return "Comanda";
      case "counter":
        return "Retirada Balcão";
      case "synkar":
        const landmark = localStorage.getItem("landmark_synkar");
        if(landmark && window.atob(landmark) && JSON.parse(window.atob(landmark))){
        	const landmarkItem = JSON.parse(window.atob(landmark))
        	return `${location ? `${location} - `: ''}${landmarkItem.landmark}`
        }
        else return 'Entrega'
      case 'pluginbot':
        const landmarkPluginbot = localStorage.getItem("landmark_pluginbot");
        if(landmarkPluginbot && window.atob(landmarkPluginbot) && JSON.parse(window.atob(landmarkPluginbot))){
        	const landmarkPluginbotItem = JSON.parse(window.atob(landmarkPluginbot))
        	return `${location ? `${location} - `: ''}${landmarkPluginbotItem.landmark}`
        }
        else return 'Entrega'
      case "internal-delivery":
        const internalDeliveryNumber = localStorage.getItem("internal_number");
        const internalDeliveryName = localStorage.getItem("internal_name");
        if (internalDeliveryNumber && internalDeliveryName)
          return `Entrega - ${window.atob(internalDeliveryName)} ${window.atob(
            internalDeliveryNumber
          )}`;
        else return "Entrega Interna";
      default:
        return "Retirada";
    }
  }

  function chooseTextAddress(typeAddress: string) {
    let textAddress = "";
    switch (typeAddress) {
      case "withdraw":
        textAddress = "Endereço de Retirada: ";
        break;
      case "delivery":
        textAddress = "Endereço de Entrega: ";
        break;
      case "internal-delivery":
        textAddress = "Local de Entrega: ";
        break;
    }
    if (textAddress && orderAddress) {
      return (
        <div
          className="store-infos"
          style={internalDelivery ? { margin: 0 } : {}}
        >
          <p>
            <b>{textAddress}</b>
            {internalDelivery ? (
              <>{internalDelivery}</>
            ) : (
              <>
                {" " +
                  orderAddress.address +
                  ", " +
                  orderAddress.number +
                  (orderAddress.complement
                    ? " " + orderAddress.complement
                    : " ") +
                  ", " +
                  orderAddress.district +
                  " - " +
                  orderAddress.city +
                  (orderAddress.reference
                    ? " - " + orderAddress.reference
                    : "") +
                  (orderAddress.cep ? " - CEP: " + orderAddress.cep : "")}
              </>
            )}
          </p>
        </div>
      );
    } else return <></>;
  }

  return (
    <div className="finalize-order">
      <ModalDelivery
        isOpen={modalIsOpen}
        setIsOpen={setModalIsOpen}
        backgroundButton={
          config?.webappcolor.webappbutton && config.webappcolor.webappbutton
        }
        fontButton={
          config?.webappcolor.fontbutton && config.webappcolor.fontbutton
        }
        goCustomer={false}
      />
      <div className="content-finalize-order">
        {!loadingHeader && (
          <Header
            background={
              config?.webappcolor.backgroundheader
                ? config?.webappcolor.backgroundheader
                : "#F5F5F5"
            }
            colorIcon={
              config?.webappcolor.iconsheader
                ? config.webappcolor.iconsheader
                : "#636363"
            }
            logo={config?.icon ? config.icon : ""}
            backgroundCart={
              config?.webappcolor.backgroundcart
                ? config.webappcolor.backgroundcart
                : "#FFBA49"
            }
            fontCart={
              config?.webappcolor.fontcart
                ? config.webappcolor.fontcart
                : "#000"
            }
            noSales={
              config &&
              config?.content &&
              config?.content.pdv &&
              config?.content.pdv.noSales
                ? config.content.pdv.noSales
                : false
            }
          />
        )}
        {loading ? (
          <div style={{ width: "100%", height: "calc(100vh)" }}>
            <Loading
              type="spinningBubbles"
              color="#FFF"
              width={64}
              height={64}
            />
          </div>
        ) : (
          <div className="finalize-order-body">
            <h2>Informações da compra</h2>
            {customer && orderAddress && (
              <div className="finalize-order-details">
                {type === "delivery" && (
                  <h4
                    onClick={() => {
                      setModalIsOpen(true);
                    }}
                  >
                    Editar
                  </h4>
                )}
                <div
                  className="customer-infos"
                  style={
                    internalDelivery || type === "counter" ? { margin: 0 } : {}
                  }
                >
                  <p>
                    <b>Cliente:</b> {customer.name}
                  </p>
                  <p>
                    <b>
                      {cpfCnpjNoMask(customer.cpf).length > 12 ? "CNPJ" : "CPF"}
                      :
                    </b>{" "}
                    {cpfCnpjNoMask(customer.cpf).length > 12
                      ? cnpjMask(cpfCnpjNoMask(customer.cpf))
                      : cpfMask(cpfCnpjNoMask(customer.cpf))}
                  </p>
                  {type === "withdraw" && (
                    <p>
                      <b>Loja:</b> {orderAddress.name}
                    </p>
                  )}
                </div>
                {chooseTextAddress(type)}
                {!internalDelivery && (
                  <p className="order-modality">
                    <b>Modalidade: </b>
                    {chooseModality()}
                  </p>
                )}
                {type === "withdraw" &&
                  orderAddress &&
                  orderAddress.otherPersonToWithdrawal && (
                    <p className="order-modality">
                      <b>Responsável pela retirada: </b>
                      {`${
                        orderAddress.otherPersonToWithdrawal.name
                          ? orderAddress.otherPersonToWithdrawal.name
                          : ""
                      } 
											${
                        orderAddress.otherPersonToWithdrawal.cpf
                          ? orderAddress.otherPersonToWithdrawal.cpf
                          : ""
                      }`}
                    </p>
                  )}
              </div>
            )}

            {sellerInfo && (
              <>
                <h2 style={{ marginTop: "2em" }}>Informações do Vendedor</h2>

                <div className="finalize-order-details">
                  <p>
                    <b>Nome: </b>
                    {sellerInfo.name}
                  </p>
                  {/*
										
											<p>
										<b>Email: </b>
										{sellerInfo.email}
									</p>
										*/}
                </div>
              </>
            )}

            <h2 style={{ marginTop: "2em" }}>Pagamento</h2>
            <div className="finalize-order-details">
              <h4 onClick={() => navigate(`/${pluginspace_id}/order`)}>
                Editar
              </h4>
              <div className="payment-infos">
                <p>
                  <b>
                    {cpfCnpjNoMask(cpfInNote).length > 12 ? "CNPJ" : "CPF"} na
                    nota:
                  </b>{" "}
                  {cpfInNote ? cpfInNote : "Não solicitado"}
                </p>
                {paymentType && (
                  <>
                    <p>
                      <b>
                        {paymentType.includes("card") && "Cartão de crédito: "}
                      </b>
                      {paymentType.includes("card") &&
                        card?.number &&
                        maskCardNumber(card.number)}
                      {paymentMethod}
                    </p>
                    <p>
                      <b>{paymentType.includes("card") && "Parcelas: "}</b>
                      {paymentType.includes("card") &&
                        card?.installments &&
                        `${card.installments}x ${floatToPrice(
                          (total + freight) / parseInt(card.installments)
                        )}`}
                      {paymentMethod}
                    </p>
                    <p>
                      {paymentType.includes("delivery-payment") && (
                        <>
                          <p>
                            <b>{"Método: "}</b>
                            Pagamento na entrega
                          </p>
                          <p>
                            <b>{"Parcelas: "}</b> 1x{" "}
                            {floatToPrice(total + freight)}
                          </p>
                        </>
                      )}
                      {(paymentType.includes("pix") ||
                        paymentType.includes("wallet") ||
                        paymentType.includes("shipay")) && (
                        <>
                          <p>
                            <b>{"Método: "}</b>PIX
                          </p>
                          <p>
                            <b>{"Parcelas: "}</b> 1x{" "}
                            {floatToPrice(total + freight)}
                          </p>
                        </>
                      )}
                    </p>
                  </>
                )}
              </div>
            </div>

            <h2 style={{ marginTop: "2em" }}>Produtos</h2>
            {order &&
              order.products.map((product) => {
                let priceAdditionals = 0;
                if (product.additionals) {
                  let tempPrice = 0;
                  product.additionals.map(
                    (additional) =>
                      (tempPrice += additional.quantity * additional.price)
                  );
                  priceAdditionals = tempPrice;
                }
                return (
                  <div className="finalize-order-details" key={product.id}>
                    <div className="product">
                      <div className="product-image">
                        {product.image ? (
                          <ImageLazy
                            name={product.name}
                            image={product.image}
                          />
                        ) : (
                          <div className="no-image" />
                        )}
                      </div>
                      <div className="product-infos">
                        <p>{product.name}</p>
                        {Object.entries(product.variation).map(
                          (variation, index) => {
                            if (
                              variation[0] !== "VARIATION" &&
                              variation[1] !== "NONE"
                            ) {
                              return (
                                <p className="variation" key={index}>
                                  {variation[0] === "NOME_COR"
                                    ? "COR"
                                    : variation[0]}
                                  : <b>{variation[1]}</b>
                                </p>
                              );
                            }
                          }
                        )}
                        {product.additionals &&
                          product.additionals.map((additional, i) => (
                            <p
                              className="additional"
                              key={`additional-${i}`}
                            >{`${additional.quantity}x ${
                              additional.name
                            } (${floatToPrice(additional.price)})`}</p>
                          ))}
                        {product.fractions &&
                          organizeFractions(product.fractions).map(
                            (fractional, i) => (
                              <p
                                className="additional"
                                key={`fractional-${i}`}
                              >{`${fractional.quantity}/${
                                product.fractions?.length
                              } ${fractional.name} (${floatToPrice(
                                fractional.price
                              )})`}</p>
                            )
                          )}
                        {product.unitPrice === product.promotionalPrice ||
                        product.promotionalPrice === 0 ? (
                          <div className="product-values">
                            <div className="values">
                              <p className="promotional">-R$ 0</p>
                              <p>
                                {product.type === "fractional"
                                  ? floatToPrice(
                                      calculatePriceFractionalToProduct(
                                        product
                                      ) *
                                        product.quantity +
                                        priceAdditionals * product.quantity
                                    )
                                  : floatToPrice(
                                      product.unitPrice * product.quantity +
                                        priceAdditionals * product.quantity
                                    )}
                              </p>
                              <p>Quantidade: {product.quantity}</p>
                            </div>
                          </div>
                        ) : (
                          <div className="product-values">
                            <div className="values">
                              <p className="promotional">
                                -
                                {floatToPrice(
                                  product.quantity *
                                    (product.unitPrice -
                                      product.promotionalPrice)
                                )}
                              </p>
                              <p>
                                {floatToPrice(
                                  product.quantity * product.promotionalPrice
                                )}
                              </p>
                              <p>Quantidade: {product.quantity}</p>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            <div className="info-to-finalize">
              <div className="row-text">
                <p>Valor dos Produtos</p>
                <p className="value">
                  {floatToPrice(
                    totalWithoutDiscount -
                      (serviceTaxesNow ? serviceTaxesNow : 0)
                  )}
                </p>
              </div>
              <div className="row-text">
                <p>Você economiza</p>
                <p>-{floatToPrice(totalWithoutDiscount - total)}</p>
              </div>
              <div className="row-text">
                <p>Valor com desconto</p>
                <p className="value">
                  {floatToPrice(
                    total - (serviceTaxesNow ? serviceTaxesNow : 0)
                  )}
                </p>
              </div>
              <div className="row-text">
                <p>Taxa de {type === "withdraw" ? "retirada" : "entrega"}</p>
                <p className="value">{floatToPrice(freight)}</p>
              </div>
              {serviceTaxesNow && (
                <div className="row-text">
                  <p>Taxa de serviço</p>
                  <p className="value">
                    {floatToPrice(retirarServico ? 0 : serviceTaxesNow)}
                  </p>
                </div>
              )}
              <div className="row-text-total">
                <p>Total da compra</p>
                <p className="value">
                  {floatToPrice(
                    total +
                      freight -
                      (retirarServico && serviceTaxesNow ? serviceTaxesNow : 0)
                  )}
                </p>
              </div>
              {serviceTaxesNow && (
                <div className="input-checkbox">
                  <Checkbox
                    name="remove-service"
                    checked={retirarServico}
                    checkMark={() => setRetirarServico(!retirarServico)}
                  />
                  <label
                    style={{ cursor: "pointer" }}
                    onClick={() => setRetirarServico(!retirarServico)}
                    htmlFor="remove-service"
                  >
                    Retirar taxas de serviço
                  </label>
                </div>
              )}
            </div>
            {config?.content.pdv.showObservation && (
              <div className="observation">
                {config?.content?.pdv?.limitCharacters &&
                config?.content?.pdv?.limitCharacters > 0 ? (
                  <>
                    <textarea
                      rows={5}
                      placeholder="Adicione uma observação..."
                      className="observation"
                      onChange={(event) => setObservation(event.target.value)}
                      maxLength={config?.content?.pdv?.limitCharacters}
                    >
                      {observation}
                    </textarea>
                    {/* * Quantidade de caracteres restantes: {config?.content?.pdv?.limitCharacters - observation?.length} */}
                    {config?.content?.pdv?.limitCharacters ? (
                      observation?.length <
                      config?.content?.pdv?.limitCharacters ? (
                        <span style={{ fontSize: "11px" }}>
                          Quantidade de caracteres digitados:{" "}
                          {observation?.length}/
                          {config?.content?.pdv?.limitCharacters}
                        </span>
                      ) : (
                        <span className="info-max-characters">
                          Limite máximo de caracteres atingido.
                        </span>
                      )
                    ) : (
                      <></>
                    )}
                  </>
                ) : (
                  <>
                    <textarea
                      rows={5}
                      placeholder="Adicione uma observação..."
                      className="observation"
                      onChange={(event) => setObservation(event.target.value)}
                    >
                      {observation}
                    </textarea>
                  </>
                )}
              </div>
            )}
            {haveGuid && (
              <div className="wpp-notification">
                <div className="icon">
                  <svg
                    width="26"
                    height="26"
                    viewBox="0 0 26 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0 25.8516C0.634451 24.0954 1.19841 22.55 1.76236 21.0045C2.11484 20.2318 2.04433 19.5995 1.62137 18.8268C-2.96078 10.2566 3.24275 -0.0698915 13.0415 0.000356456C19.386 0.000356456 24.8846 4.84747 25.7305 11.1698C26.8584 19.3888 20.0204 26.4838 11.7021 25.6409C10.4332 25.5004 9.09376 25.0086 7.89535 24.5169C7.11991 24.2359 6.48548 24.0954 5.71004 24.3764C4.08867 24.8681 2.4673 25.2896 0.91642 25.7111C0.634442 25.7111 0.422967 25.7111 0 25.8516ZM16.3547 19.8103C17.9056 19.8103 19.0335 19.1078 19.5975 18.1243C20.2319 17.0004 20.0204 16.1574 18.822 15.5252C18.6105 15.3847 18.3286 15.2442 18.0466 15.1739C16.3547 14.3309 16.3547 14.2607 15.2268 15.7359C14.8038 16.2979 14.3809 16.3681 13.8169 16.0169C12.1955 15.1739 10.9266 13.9797 9.93971 12.5045C9.51675 11.8723 9.44623 11.3103 10.0102 10.678C10.4332 10.1863 10.7152 9.62433 10.4332 8.92185C10.0807 8.07887 9.79871 7.2359 9.44624 6.46317C9.23476 5.90119 8.8118 5.69045 8.17735 5.76069C6.69696 5.97144 5.35757 8.14913 5.71004 9.69458C6.69696 13.5582 9.09378 16.3681 12.407 18.4053C13.7464 19.2483 15.0858 19.74 16.3547 19.8103Z"
                      fill="#636363"
                    />
                  </svg>
                </div>
                <div className="info">
                  <p>
                    Aceito ser comunicado via WhatsApp sobre promoções, status
                    de pedidos
                  </p>
                  <div className="options">
                    <div className="option">
                      <input
                        type="radio"
                        name="whatsapp"
                        checked={useWpp === true}
                        onChange={() => setUseWpp(true)}
                      />
                      <label>Aceito</label>
                    </div>
                    <div className="option">
                      <input
                        type="radio"
                        name="whatsapp"
                        checked={useWpp === false}
                        onChange={() => setUseWpp(false)}
                      />
                      <label>Não aceito</label>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {!haveGuid ? (
              <>
                {paymentType && (
                  <div className="button-finalize">
                    {paymentType.includes("pix") ||
                    paymentType.includes("wallet") ||
                    paymentType.includes("shipay") ? (
                      <MainButton
                        color={
                          config?.webappcolor.fontbutton
                            ? config.webappcolor.fontbutton
                            : "#636363"
                        }
                        backgroundColor={
                          config?.webappcolor.webappbutton
                            ? config.webappcolor.webappbutton
                            : "#EAEAEA"
                        }
                        text="Gerar QRCode"
                        onClick={generateQRCode}
                      />
                    ) : (
                      <MainButton
                        color={
                          config?.webappcolor.fontbutton
                            ? config.webappcolor.fontbutton
                            : "#636363"
                        }
                        backgroundColor={
                          config?.webappcolor.webappbutton
                            ? config.webappcolor.webappbutton
                            : "#EAEAEA"
                        }
                        text={
                          isTable || isCard
                            ? "Confirmar Pagamento"
                            : "Confirmar Compra"
                        }
                        onClick={finalizeOrder}
                      />
                    )}
                  </div>
                )}
              </>
            ) : (
              <>
                {acceptTerm || !config?.content.pdv.termsActive ? (
                  <>
                    {paymentType && (
                      <div className="button-finalize">
                        {paymentType.includes("pix") ||
                        paymentType.includes("wallet") ||
                        paymentType.includes("shipay") ? (
                          <MainButton
                            color={
                              config?.webappcolor.fontbutton
                                ? config.webappcolor.fontbutton
                                : "#636363"
                            }
                            backgroundColor={
                              config?.webappcolor.webappbutton
                                ? config.webappcolor.webappbutton
                                : "#EAEAEA"
                            }
                            text="Gerar QRCode"
                            onClick={generateQRCode}
                          />
                        ) : (
                          <MainButton
                            color={
                              config?.webappcolor.fontbutton
                                ? config.webappcolor.fontbutton
                                : "#636363"
                            }
                            backgroundColor={
                              config?.webappcolor.webappbutton
                                ? config.webappcolor.webappbutton
                                : "#EAEAEA"
                            }
                            text="Confirmar Compra"
                            onClick={finalizeOrder}
                          />
                        )}
                      </div>
                    )}
                  </>
                ) : (
                  <MainButton
                    color={
                      config?.webappcolor.fontbutton
                        ? config.webappcolor.fontbutton
                        : "#636363"
                    }
                    backgroundColor={
                      config?.webappcolor.webappbutton
                        ? config.webappcolor.webappbutton
                        : "#EAEAEA"
                    }
                    text="Termos de Consentimento"
                    onClick={readTerms}
                  />
                )}
              </>
            )}
          </div>
        )}
        {!loadingHeader && (
          <Menu
            activeMenu="cart"
            fontColor={
              config?.webappcolor.iconsfooter
                ? config?.webappcolor.iconsfooter
                : "#636363"
            }
            activeFontColor={
              config?.webappcolor.highlightfooter
                ? config?.webappcolor.highlightfooter
                : "#000"
            }
            backgroundMenu={
              config?.webappcolor.backgroundfooter
                ? config?.webappcolor.backgroundfooter
                : "#F5F5F5"
            }
            colorIcons={
              config?.webappcolor.iconsfooter
                ? config?.webappcolor.iconsfooter
                : "#636363"
            }
            highlightColorIcons={
              config?.webappcolor.highlightfooter
                ? config?.webappcolor.highlightfooter
                : "#636363"
            }
            backgroundCart={
              config?.webappcolor.backgroundcart
                ? config.webappcolor.backgroundcart
                : "#FFBA49"
            }
            fontCart={
              config?.webappcolor.fontcart
                ? config.webappcolor.fontcart
                : "#000"
            }
            noSales={
              config &&
              config?.content &&
              config?.content.pdv &&
              config?.content.pdv.noSales
                ? config.content.pdv.noSales
                : false
            }
          />
        )}
        {openTerms && (
          <ModalTerms
            isOpen={openTerms}
            setIsOpen={setOpenTerms}
            termContent={term}
            backgroundButton={
              config?.webappcolor.webappbutton &&
              config.webappcolor.webappbutton
            }
            fontButton={
              config?.webappcolor.fontbutton && config.webappcolor.fontbutton
            }
            acceptTerm={acceptTerm}
            setAcceptTerm={setAcceptTerm}
          />
        )}
      </div>

      <ModalFinalizaVendaFood
        isOpen={openModalFinalizaVendaFood}
        setOpenModal={setOpenModalFinalizaVendaFood}
        typeModal={typeModal}
        errorInfo={errorInfo}
      />
    </div>
  );
}
